<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';

const { content, contentAttributes, contentType } = useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (!item) return [];

    return [
      {
        title: item.title,
        value: item.value,
        label: '',
      },
    ];
  }

  return [];
});

const buttonItems = computed(() => {
  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const { items = [], submittedValues = [] } = contentAttributes.value || {};
    if (submittedValues.length === 0) {
      return items;
    }
  }
  return [];
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <span
      v-dompurify-html="content"
      class="whitespace-pre-wrap"
      :title="content"
    />

    <dl v-if="formValues.length" class="mt-4">
      <template v-for="item in formValues" :key="item.title">
        <dt class="text-n-slate-11 italic mt-2">
          {{ item.label || t('CONVERSATION.RESPONSE') }}
        </dt>
        <dd>{{ item.title }}</dd>
      </template>
    </dl>
    <div v-else-if="isAWebWidgetInbox" class="my-2 font-medium">
      {{ t('CONVERSATION.NO_RESPONSE') }}
    </div>

    <div v-if="buttonItems.length" class="flex flex-col gap-2 mt-4">
      <div
        v-for="(item, index) in buttonItems"
        :key="`btn-${index}`"
        class="w-full px-3 py-2 text-sm font-semibold text-n-blue-11 bg-white dark:bg-n-solid-3 rounded-lg shadow-sm border border-n-strong text-center truncate cursor-default opacity-80"
      >
        {{ item.title }}
      </div>
    </div>
  </BaseBubble>
</template>
